import type { SetupTourDefinition } from '../core/types';

export const INSURANCES_SETUP_TOUR_TARGETS = {
  sidebarInsurancesLink: 'insurances-sidebar-link',
  addInsuranceButton: 'insurances-list-add-button',
  insuranceForm: 'insurances-create-form',
  submitButton: 'insurances-submit-button',
} as const;

export const insurancesSetupTour: SetupTourDefinition = {
  id: 'insurances_setup',
  label: 'Insurances Setup',
  onboardingKey: 'insurances_setup',
  sidebarTargetsByRoute: {
    '/insurances': INSURANCES_SETUP_TOUR_TARGETS.sidebarInsurancesLink,
  },
  steps: [
    {
      id: 'sidebar-insurances',
      route: '/insurances',
      target: INSURANCES_SETUP_TOUR_TARGETS.sidebarInsurancesLink,
      content: 'Click Insurances in the sidebar to set up rental coverage options.',
      advanceOnTargetClick: true,
      expandSidebarKeys: ['/pricing'],
    },
    {
      id: 'add-insurance',
      route: '/insurances',
      target: INSURANCES_SETUP_TOUR_TARGETS.addInsuranceButton,
      content: 'Click Add New Insurance to create your first insurance.',
      advanceOnTargetClick: true,
    },
    {
      id: 'insurance-form',
      route: '/insurances/create',
      target: INSURANCES_SETUP_TOUR_TARGETS.insuranceForm,
      content:
        'Insurance Name is required, while Description is optional. Create saves the insurance when the form is complete.',
      showRequiredFieldsOnEnter: true,
      directNextTargets: [INSURANCES_SETUP_TOUR_TARGETS.submitButton],
      next: {
        label: 'Create',
        guardTarget: INSURANCES_SETUP_TOUR_TARGETS.insuranceForm,
        action: { type: 'submit' },
        waitForTargetRemoval: INSURANCES_SETUP_TOUR_TARGETS.insuranceForm,
        completesTour: true,
      },
    },
  ],
};
